import { RawStatisticsItem, StatisticsDataPoint } from '../types';

export function transformDataForChart(
  data: RawStatisticsItem[],
  valueKey: keyof RawStatisticsItem,
  dateKey: 'data_romaneio' | 'data_aprovacao' = 'data_romaneio'
): StatisticsDataPoint[] {
  if (!Array.isArray(data)) {
    return [];
  }

  return data
    .map((item) => {
      const rawValue = item[valueKey];
      const numericValue =
        typeof rawValue === 'string' ? parseFloat(rawValue) : rawValue || 0;

      return {
        date: (item[dateKey] as string) || '',
        value: isNaN(numericValue as number) ? 0 : (numericValue as number),
      };
    })
    .filter((item) => item.date && item.value !== undefined)
    .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
}
